import React from "react";
import companyInfo from "../data/companyInfo";

function Home() {
  const { federal } = companyInfo;

  return (
    <header className="bizmak-hero text-center text-lg-start" id="page-top">
      <div className="container">
        <div className="row align-items-center gy-5">
          <div className="col-lg-6">
            <p className="bizmak-eyebrow">IT Consulting &amp; Federal Contracting</p>
            <h1 className="mb-4">
              Enterprise software and IT services for business and government
            </h1>
            <p className="lead-hero mb-4">
              BizMak Inc builds, secures, and operates the systems organizations
              depend on — custom software, cloud, QA automation, and
              cybersecurity. Trusted by Fortune 500 companies and registered to
              serve federal agencies.
            </p>
            <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start">
              <a
                className="btn btn-bizmak-gold btn-lg text-uppercase"
                href="#fedsupplier"
              >
                Government buyers
              </a>
              <a
                className="btn btn-bizmak-outline-light btn-lg text-uppercase"
                href="#service"
              >
                Commercial services
              </a>
            </div>
            <div className="bizmak-stat-row justify-content-center justify-content-lg-start">
              <div className="bizmak-stat">
                <strong>DoD · Navy</strong>
                <span>Active contract</span>
              </div>
              <div className="bizmak-stat">
                <strong>Fortune 500</strong>
                <span>Client base</span>
              </div>
              <div className="bizmak-stat">
                <strong>SAM.gov</strong>
                <span>Active registration</span>
              </div>
              <div className="bizmak-stat">
                <strong>{federal.naicsCodes.length}</strong>
                <span>NAICS codes</span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 bizmak-hero-visual">
            <div className="bizmak-cred-card" aria-label="Federal credentials">
              <p className="bizmak-cred-card-label">Certified Federal Supplier</p>
              <div className="bizmak-cred-row">
                <span>Past performance</span>
                <strong>DoD — U.S. Navy</strong>
              </div>
              <div className="bizmak-cred-row">
                <span>Unique Entity ID</span>
                <strong>{federal.uei}</strong>
              </div>
              <div className="bizmak-cred-row">
                <span>CAGE Code</span>
                <strong>{federal.cageCode}</strong>
              </div>
              <div className="bizmak-cred-row">
                <span>Primary NAICS</span>
                <strong>{federal.primaryNaics}</strong>
              </div>
              <div className="bizmak-cred-row">
                <span>Registration</span>
                <strong>SAM.gov — Active</strong>
              </div>
              <a
                className="btn btn-bizmak-gold w-100 mt-3 text-uppercase"
                href={federal.capabilityStatementUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Capability statement
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Home;
